// client/src/pages/AdminDashboard.js

import React, { useEffect, useState } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ManageCategories from './admin/ManageCategories';
import ManageProducts from './admin/ManageProducts';
import ManageBlogs from './admin/ManageBlogs';
import ManageOrders from './admin/ManageOrders';
import ManageUsers from './admin/ManageUsers';
import ManagePages from './admin/ManagePages';

import ManageHome from './admin/ManageHome'; // <-- import the new page

import axios from 'axios';

export default function AdminDashboard() {
  const [isAllowed, setIsAllowed] = useState(false);
  const [stats, setStats] = useState({ users: 0, products: 0, orders: 0 });

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const userStr = localStorage.getItem('userInfo');
    if (!token || !userStr) {
      window.location.href = '/login';
    } else {
      const user = JSON.parse(userStr);
      if (!user.isAdmin) {
        window.location.href = '/login';
      } else {
        setIsAllowed(true);
        fetchStats(token);
      }
    }
  }, []);

  const fetchStats = async (token) => {
    try {
      // example calls to fetch counts
      const [usersRes, productsRes, ordersRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/api/admin/users`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${process.env.REACT_APP_API_URL}/api/admin/product`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${process.env.REACT_APP_API_URL}/api/admin/orders`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setStats({
        users: usersRes.data.length,
        products: productsRes.data.length,
        orders: ordersRes.data.length
      });
    } catch (err) {
      console.error('Error fetching admin stats:', err);
    }
  };

  if (!isAllowed) {
    return <div className="p-4 mt-16">Checking admin access...</div>;
  }

  return (
    <div className="flex min-h-screen mt-16">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow p-6">
        <h2 className="text-2xl font-bold mb-6">Admin Panel</h2>
        <ul className="space-y-2">
          <li>
            <Link to="/admin-dashboard/home" className="block hover:underline">
              Manage Home
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/categories" className="block hover:underline">
              Categories
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/products" className="block hover:underline">
              Products
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/blogs" className="block hover:underline">
              Blogs
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/users" className="block hover:underline">
              Users
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/orders" className="block hover:underline">
              Orders
            </Link>
          </li>
          <li>
            <Link to="/admin-dashboard/pages" className="block hover:underline">
              Pages
            </Link>
          </li>
        </ul>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-6 bg-gray-50">
        {/* A quick "dashboard" style row of stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-white p-4 rounded shadow text-center">
            <h3 className="text-xl font-bold mb-2">Total Users</h3>
            <p className="text-3xl font-semibold text-primaryGreen">{stats.users}</p>
          </div>
          <div className="bg-white p-4 rounded shadow text-center">
            <h3 className="text-xl font-bold mb-2">Total Products</h3>
            <p className="text-3xl font-semibold text-primaryGreen">{stats.products}</p>
          </div>
          <div className="bg-white p-4 rounded shadow text-center">
            <h3 className="text-xl font-bold mb-2">Total Orders</h3>
            <p className="text-3xl font-semibold text-primaryGreen">{stats.orders}</p>
          </div>
        </div>

        <Routes>
          <Route path="home" element={<ManageHome />} />
          <Route path="categories" element={<ManageCategories />} />
          <Route path="products" element={<ManageProducts />} />
          <Route path="blogs" element={<ManageBlogs />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="orders" element={<ManageOrders />} />
          <Route path="pages" element={<ManagePages />} />
        </Routes>
      </main>
    </div>
  );
}
